import React, {useState, useEffect} from 'react';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import {
    Button,
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    FormControlLabel,
    Checkbox,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import DateRangeSelector from '../../../components/date/DateRangeSelector';
import StatisticsCheckbox from '../../../components/date/StatisticsCheckbox';
import SelectMulti from '../../../components/select/SelectMulti';
import {fetchFields, fetchDspList, fetchSspList} from '../../../API/BlockedCridsReport';
import useApi from '../../../hooks/useApi';
import Cookies from 'js-cookie';

function GeoEdgeBlockedCreativesOptions({onSubmit}) {
    const [selectedDsp, setSelectedDsp] = useState([]);
    const [selectedSsp, setSelectedSsp] = useState([]);
    const [showDsp, setShowDsp] = useState(false);
    const [showSsp, setShowSsp] = useState(false);

    const {data: dspList} = useApi(fetchDspList);
    const {data: sspList} = useApi(fetchSspList);
    const {data: statistics} = useApi(fetchFields);

    const today = new Date();
    const firstDayPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    const lastDayPrevMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const [options, setOptions] = useState({
        start_date: firstDayPrevMonth,
        end_date: lastDayPrevMonth,
        stat: [],
        dsp: [],
        ssp: [],
        crid: '',
        status: 'all',
    });

    const handleDateChange = (event) => {
        const endDate = new Date(event.endDate);
        endDate.setHours(12, 12, 12, 12);
        const endDateISOString = endDate.toISOString().split('T')[0];

        const startDate = new Date(event.startDate);
        startDate.setHours(12, 12, 12, 12);
        const startDateISOString = startDate.toISOString().split('T')[0];

        if (endDate && startDate) {
            setOptions((prevOptions) => ({
                ...prevOptions,
                start_date: startDateISOString,
                end_date: endDateISOString,
            }));
        }
    };

    useEffect(() => {
        const storedValue = Cookies.get('GeoEdgeBlockedCreatives');
        if (storedValue) {
            const parsedValue = JSON.parse(storedValue);
            setOptions(parsedValue);
            setSelectedDsp(parsedValue.dsp || []);
            setSelectedSsp(parsedValue.ssp || []);
        }
    }, []);

    const handleCheckboxChangeStat = (event) => {
        const {name, checked} = event.target;
        let stat = [...options.stat];

        if (checked) {
            stat.push(name);
        } else {
            stat = stat.filter((item) => item !== name);
        }

        setOptions({...options, stat});
    };

    const handleSubmit = async (event) => {
        onSubmit(options);
    };

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            dsp: selectedDsp,
            ssp: selectedSsp,
        }));
    }, [selectedDsp, selectedSsp]);

    return (
        <Grid container spacing={2} sx={{width: "100%", marginLeft: '0px',}}>
            <Accordion sx={{width: "100%"}}>
                <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownOutlinedIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{backgroundColor: '#f0f3f5', width: "100%"}}
                >
                    Options
                </AccordionSummary>
                <AccordionDetails sx={{width: "100%"}}>
                    <form onSubmit={handleSubmit}>
                        <Grid item xs={12} md={12} sx={{width: "100%", margin: '0px 0 25px auto'}}>
                            <Grid item xs={12} md={12}>
                                {Object.keys(statistics).length != 0 ? (<strong>Data</strong>) : ''}
                            </Grid>
                            {statistics?.map((statistic) => (
                                <StatisticsCheckbox
                                    key={statistic.key}
                                    statistic={statistic}
                                    checked={options.stat.includes(statistic.key)}
                                    onChange={handleCheckboxChangeStat}
                                />
                            ))}
                        </Grid>

                        <Grid item xs={12} md={12} sx={{width: "100%", margin: '25px 0 25px auto'}}>
                            <Grid item xs={12} md={12}>
                                <strong>Filters</strong>
                            </Grid>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    {Object.keys(dspList).length != 0 ? (<FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showDsp}
                                                onChange={() => setShowDsp(!showDsp)}
                                                name="dsp"
                                            />
                                        }
                                        label="DSP"
                                    />) : ''}

                                    {Object.keys(sspList).length != 0 ? (<FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={showSsp}
                                                onChange={() => setShowSsp(!showSsp)}
                                                name="ssp"
                                            />
                                        }
                                        label="SSP"
                                    />) : ''}
                                </Grid>

                                <Grid item xs={6}>
                                    {showDsp && (
                                        <SelectMulti
                                            label="DSP endpoint"
                                            items={dspList}
                                            selectedItems={selectedDsp}
                                            onChange={(event) => setSelectedDsp(event.target.value)}
                                            itemLabel="value.name"
                                            itemKey="value.id"
                                            itemValue="value.id"
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={6}>
                                    {showSsp && (
                                        <SelectMulti
                                            label="SSP endpoint"
                                            items={sspList}
                                            selectedItems={selectedSsp}
                                            onChange={(event) => setSelectedSsp(event.target.value)}
                                            itemLabel="value.name"
                                            itemKey="value.id"
                                            itemValue="value.id"
                                        />
                                    )}
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Creative ID"
                                        value={options.crid || ''}
                                        onChange={(event) => setOptions({...options, crid: event.target.value})}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="status-label">Status</InputLabel>
                                        <Select
                                            labelId="status-label"
                                            label="Status"
                                            value={options.status || 'all'}
                                            onChange={(event) => setOptions({...options, status: event.target.value})}
                                        >
                                            <MenuItem value="all">All</MenuItem>
                                            <MenuItem value="blocked">Blocked only</MenuItem>
                                            <MenuItem value="unblocked">Unblocked only</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </AccordionDetails>
            </Accordion>

            <Grid item xs={6} md={6}>
                <Button
                    size={"large"}
                    startIcon={<BackupTableOutlinedIcon fontSize="small"/>}
                    onClick={handleSubmit}
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{marginLeft: '-15px'}}
                >
                    Generate Report
                </Button>
            </Grid>

            <Grid item xs={6} md={6}>
                <DateRangeSelector
                    initialRange={{startDate: firstDayPrevMonth, endDate: lastDayPrevMonth, key: 'selection'}}
                    onRangeChange={handleDateChange}
                />
            </Grid>
        </Grid>
    );
}

export default GeoEdgeBlockedCreativesOptions;
